export function fFormatPrice(value: number, currencyCode: string): string {
  const symbol = {
    EUR: '€',
    USD: '$',
    GBP: '£',
  }[currencyCode]
  return `${symbol}${(value / 100).toFixed(2).replace('.', ',')}`
}
